import React from "react";

const VectorGround = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 200 100"
        preserveAspectRatio="none"
    >
        <path
            d="M0,100 Q25,85 50,70 T100,55 T150,40 T200,45 L200,100 Z"
            fill="#07162a"
        />
    </svg>
);

export default React.memo(VectorGround);
